
/**
* this file was autogenerated by the icon-renderer module
* the settings for this are in the nuxt.config.ts file
* if you would like to override the contents in this file you can create a custom component in the
* assets/icons directory and name it the same as the icon you would like to override
* */
<template>
  <svg version="1.1" id="Layer_1" xmlns:x="ns_extend;" xmlns:i="ns_ai;" xmlns:graph="ns_graphs;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 182.4 58" style="enable-background:new 0 0 182.4 58;" xml:space="preserve">
    <metadata>
    <sfw xmlns="ns_sfw;">
    <slices>
    </slices>
    <sliceSourceBounds bottomLeftOrigin="true" height="58" width="182.4" x="-38.2" y="-12.1">
    </sliceSourceBounds>
    </sfw>
    </metadata>
    <g>
    <g>
    <path class="st0" d="M28.4,56.8C12.7,56.8,0,44.1,0,28.4C0,12.7,12.7,0,28.4,0c15.7,0,28.4,12.7,28.4,28.4
    C56.8,44.1,44.1,56.8,28.4,56.8z M28.4,12.7c-8.7,0-15.8,7.1-15.8,15.8c0,8.7,7.1,15.8,15.8,15.8s15.8-7.1,15.8-15.8
    C44.2,19.7,37.1,12.7,28.4,12.7z">
    </path>
    </g>
    <path d="M75.9,47.7h8.9V11.6h-8.9V47.7z M102.9,48.5c10.9,0,14.8-6.8,14.8-13.7s-3.9-13.7-14.8-13.7c-10.9,0-14.8,6.8-14.8,13.7
    C88.1,41.8,91.9,48.5,102.9,48.5z M97,34.8c0-5.2,1.7-6.8,5.9-6.8s5.9,1.7,5.9,6.8c0,5.2-1.7,6.8-5.9,6.8S97,39.9,97,34.8z
    M134.7,48.5c10.9,0,14.8-6.8,14.8-13.7s-3.9-13.7-14.8-13.7c-10.9,0-14.8,6.8-14.8,13.7C119.9,41.8,123.7,48.5,134.7,48.5z
    M128.8,34.8c0-5.2,1.7-6.8,5.9-6.8c4.2,0,5.9,1.7,5.9,6.8c0,5.2-1.7,6.8-5.9,6.8C130.4,41.6,128.8,39.9,128.8,34.8z M170.5,21.1
    c-4.4,0-7.3,1.6-9.1,4.3v-3.5h-8.9V58h8.9V44.1c1.8,2.8,4.7,4.4,9.1,4.4c8.5,0,11.8-6.5,11.8-13.7C182.4,27.4,179,21.1,170.5,21.1z
    M167.6,41.6c-4.5,0-6.1-2.2-6.1-6.8c0-4.6,1.5-6.8,6.1-6.8c4.4,0,5.9,2,5.9,6.8C173.5,39.6,171.9,41.6,167.6,41.6z">
    </path>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'Loopreturns',
    inheritAttrs: true,
  }
</script>
